const InitProductQna = () => {
  document.addEventListener('DOMContentLoaded', function () {
    const root = document.querySelector('[data-dcraft-qna]');
    if (!root || typeof frontendAjaxObject === 'undefined') return;

    const productId = parseInt(root.dataset.productId, 10);
    const perPage = parseInt(root.dataset.perPage, 10) || 2;

    const listEl = root.querySelector('[data-qna-list]');
    const paginationEl = root.querySelector('[data-qna-pagination]');
    const formEl = root.querySelector('[data-qna-form]');
    const messageEl = root.querySelector('[data-qna-form-message]');
    const openForm = root.querySelector('[data-qna-open-form]');
    const viewMyBtn = root.querySelector('[data-qna-view-my]');
    const viewAllBtn = root.querySelector('[data-qna-view-all]');
    const formWrapper = root.querySelector('[data-qna-form-wrapper]');

    let currentPage = 1;
    let isLoading = false;

    if (openForm && formWrapper) {
      openForm.addEventListener('click', function () {
        formWrapper.classList.toggle('is-open');
      });
      viewMyBtn.addEventListener('click', function () {
        if (!document.body.classList.contains('logged-in')) {
          alert('내 Q&A 보기는 로그인 후 이용하실 수 있습니다.');
          return;
        }
        loadPage(1, true);
      });
      viewAllBtn.addEventListener('click', function () {
        loadPage(1, false);
      });
    }

    function buildQuery(params) {
      const usp = new URLSearchParams(params);
      return usp.toString();
    }
    function renderPagination(current, max) {
      if (!paginationEl) return;
      if (max <= 1) {
        paginationEl.innerHTML = '';
        return;
      }

      let html = '<div class="dcraft-qna__pagination-inner">';

      if (current > 1) {
        html += `<button type="button" class="dcraft-qna__page-btn" data-page="${current - 1}">이전</button>`;
      }

      for (let i = 1; i <= max; i++) {
        html += `<button 
          type="button" 
          class="dcraft-qna__page-btn${i === current ? ' is-active' : ''}" 
          data-page="${i}">
          ${i}
        </button>`;
      }

      if (current < max) {
        html += `<button type="button" class="dcraft-qna__page-btn" data-page="${current + 1}">다음</button>`;
      }

      html += '</div>';
      paginationEl.innerHTML = html;

      paginationEl.querySelectorAll('[data-page]').forEach((btn) => {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          const page = parseInt(this.dataset.page, 10);
          loadPage(page);
          return false;
        });
      });
    }

    function initialProcess() {
      const qnaItems = root.querySelectorAll('[data-qna-item]');
      qnaItems.forEach((item) => {
        const questionEl = item.querySelector('[data-qna-question]');
        if (questionEl) {
          questionEl.addEventListener('click', function () {
            item.classList.toggle('is-open');
          });
        }
      });

      document.querySelectorAll(['[data-qna-item]']).forEach((item) => {
        const input = item.querySelector('input[name="question_password"]');
        const button = item.querySelector('[data-qna-view-password]');

        if (!input || !button) return;
        const qnaId = item.getAttribute('data-qna-id');

        const handleViewPassword = () => {
          const password = input.value.trim();
          if (!password) return;
          const query = buildQuery({
            action: 'dcraft_view_product_qna',
            nonce: frontendAjaxObject.nonce,
            qna_id: qnaId,
            password: password,
          });
          fetch(frontendAjaxObject.ajaxurl + '?' + query, {
            method: 'GET',
            credentials: 'same-origin',
          })
            .then((res) => res.json())
            .then((json) => {
              if (!json || !json.success) {
                alert(
                  (json && json.data && json.data.message) ||
                    '비밀번호가 올바르지 않습니다.'
                );
                return;
              }
              const data = json.data;
              const answerEl = item.querySelector(
                '.dcraft-qna__question-content'
              );
              if (answerEl) {
                answerEl.innerHTML = data.answer_html || '';
                item.classList.add('is-open');
              }
            })
            .catch(() => {
              alert('비밀번호 확인 중 오류가 발생했습니다.');
            });
        };
        input.addEventListener('keypress', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleViewPassword();
          }
        });
        button.addEventListener('click', function (e) {
          e.preventDefault();
          handleViewPassword();
        });
      });
      document.body.addEventListener('click', function (e) {
        if (
          e.target.matches('[data-qna-delete-guest]') ||
          e.target.matches('[data-qna-delete-author]')
        ) {
          const mode = e.target.matches('[data-qna-delete-guest]')
            ? 'guest'
            : 'author';
          const qnaItem = e.target.closest('[data-qna-item]');
          if (!qnaItem) return;
          const qnaId = qnaItem.getAttribute('data-qna-id');
          let password;
          console.log(mode);
          if (mode === 'guest') {
            password = prompt('문의글 삭제를 위해 비밀번호를 입력해주세요.');
            if (!password) return;
          } else {
            const confirmDelete = confirm('정말로 문의글을 삭제하시겠습니까?');
            if (!confirmDelete) return;
            password = '';
          }

          const formData = new FormData();
          formData.append('action', 'dcraft_delete_product_qna');
          formData.append('nonce', frontendAjaxObject.nonce);
          formData.append('qna_id', qnaId);
          formData.append('password', password);
          formData.append('mode', mode);

          fetch(frontendAjaxObject.ajaxurl, {
            method: 'POST',
            credentials: 'same-origin',
            body: formData,
          })
            .then((res) => res.json())
            .then((json) => {
              if (!json || !json.success) {
                alert(
                  (json && json.data && json.data.message) ||
                    '문의글 삭제에 실패했습니다.'
                );
                return;
              }
              const data = json.data;
              if (data && data.message) {
                qnaItem.remove();
                alert(data.message);
              }
            })
            .catch(() => {
              alert('문의글 삭제 중 오류가 발생했습니다.');
            });
        }
      });
    }

    function loadPage(page, my = false) {
      if (isLoading) return;
      isLoading = true;
      currentPage = page;

      paginationEl.innerHTML = '';
      listEl.innerHTML = '<p>문의 목록을 불러오는 중입니다...</p>';

      const query = buildQuery({
        action: 'dcraft_get_product_qna',
        nonce: frontendAjaxObject.nonce,
        product_id: productId,
        paged: my ? 1 : page,
        mode: my ? 'my' : 'all',
        per_page: my ? '1000' : perPage,
      });

      console.log(query);
      fetch(frontendAjaxObject.ajaxurl + '?' + query, {
        method: 'GET',
        credentials: 'same-origin',
      })
        .then((res) => res.json())
        .then((json) => {
          if (!json || !json.success) {
            listEl.innerHTML = `<p>${(json && json.data && json.data.message) || '목록을 불러오지 못했습니다.'}</p>`;
            return;
          }

          const data = json.data;
          listEl.innerHTML = data.html || '';
          renderPagination(data.current || 1, data.max_page || 1);
        })
        .catch(() => {
          listEl.innerHTML = '<p>목록을 불러오지 못했습니다.</p>';
        })
        .finally(() => {
          isLoading = false;
          initialProcess();
        });
    }

    if (formEl) {
      formEl.addEventListener('submit', function (e) {
        e.preventDefault();
        if (isLoading) return;

        const formData = new FormData(formEl);
        formData.append('action', 'dcraft_submit_product_qna');
        formData.append('nonce', frontendAjaxObject.nonce);

        messageEl.textContent = '등록 중입니다...';

        fetch(frontendAjaxObject.ajaxurl, {
          method: 'POST',
          credentials: 'same-origin',
          body: formData,
        })
          .then((res) => res.json())
          .then((json) => {
            if (!json || !json.success) {
              messageEl.textContent =
                (json && json.data && json.data.message) ||
                '등록에 실패했습니다.';
              return;
            }

            messageEl.textContent = json.data.message || '등록되었습니다.';

            // 폼 초기화
            formEl.reset();

            // 첫 페이지 다시 로드
            loadPage(1);
          })
          .catch(() => {
            messageEl.textContent = '등록에 실패했습니다.';
          })
          .finally(() => {
            isLoading = false;
            setTimeout(() => {
              messageEl.textContent = '';
              openForm.click();
            }, 2000);
          });
      });
    }

    loadPage(1);
  });
};
export default InitProductQna;
